import { jsx as _jsx } from "react/jsx-runtime";
import { ThemeProvider as MatThemeProvider } from '@mui/material/styles';
import { theme } from '../theme';
import { theme as bpBreakpointTheme } from '../theme/customBreakpoint';
export const ThemeProvider = (props) => {
    const { providerProps = {}, bpBreakpoint = false } = props;
    return (_jsx(MatThemeProvider, Object.assign({ theme: bpBreakpoint ? bpBreakpointTheme : theme }, providerProps, { children: props.children })));
};
export default ThemeProvider;
